module.exports = __webpack_public_path__ + "static/media/banner_andarBaharVR-half.44136d6e.png";